<template>
  <div>
    <el-card style="margin: 30px;min-height: 1000px;width: 100%">
      <div style="width: 100%;display: flex">
        <div style="display: flex;width: 12%;">
          <el-tree default-expand-all :expand-on-click-node="false" style="margin-top: 20px;width: 100%"
                   :data="menuData" :props="defaultProps"
                   @node-click="handleNodeClick"></el-tree>
        </div>
        <div style="width: 3%;display: flex;justify-content: center">
          <div style="height: 960px;background-color: #f1f1f1;width: 2px;margin-top: 20px"></div>
        </div>
        <div style="width: 85%">
          <div style="margin-top: 20px;margin-left: 20px">
            <el-button @click="addBtn" v-if="addBtnState && btnList.includes('permission_add')" size="small" type="success">新增权限</el-button>
            <div v-if="!addBtnState" style="color: #ce272d">*一级页面没有办法添加权限*</div>
            <el-table
                border
                :data="tableData"
                style="width: 96%;margin-top: 30px">
              <el-table-column
                  prop="menu_name"
                  align="center"
                  header-align="center"
                  label="权限名称">
              </el-table-column>
              <el-table-column
                  prop="action"
                  align="center"
                  header-align="center"
                  label="权限编码">
              </el-table-column>
              <el-table-column
                  align="center"
                  header-align="center"
                  label="操作">
                <template slot-scope="scope">
                  <el-button v-if="btnList.includes('permission_edit')" @click="editBtn(scope.row)" type="success" size="mini">修改</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

      </div>
    </el-card>
    <a-modal
        :visible="dialogState"
        cancel-text="取消"
        ok-text="确认"
        :title="dialogTitle"
        width="400px"
        @cancel="dialogCancel"
        @ok="ruleFormSubmit('ruleForm')"
    >
      <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          class="small-space"
          label-position="right"
          label-width="100px"
      >
        <el-form-item label="权限名称" prop="menuName">
          <el-input v-model="ruleForm.menuName" clearable placeholder="请输入权限名称" size="small"
                    style="width: 200px" type="text"></el-input>
        </el-form-item>
        <el-form-item label="权限编码" prop="action">
          <el-input :disabled="dialogTitle === '编辑权限'" clearable v-model="ruleForm.action" placeholder="请输入权限编码"
                    size="small"
                    style="width: 200px" type="text"></el-input>
        </el-form-item>
      </el-form>
    </a-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      currentClickItem: {},//当前选中的节点
      menuData: [],
      defaultProps: {
        children: 'childMap',
        label: 'page_name'
      },
      tableData: [],
      dialogState: false,
      dialogTitle: '',
      ruleForm: {
        menuName: '',
        action: '',
        sysPageId: 0
      },
      rules: {
        menuName: [{required: true, message: "请输入权限名称", trigger: "blur"}],
        action: [{required: true, message: "请输入权限编码", trigger: "blur"}],
      },
      addBtnState: false,


      btnList:[]
    }
  },
  created() {
    this.getMenuList();
    //获取用户当前页面的按钮权限
    if(this.$store.state.buttonPermission&&this.$store.state.buttonPermission.length){
      this.btnList = []
      this.$store.state.buttonPermission.forEach((item)=>{
        if (item.page_code === '/system/jurisdiction'){
          this.btnList.push(item.action)
        }
      })
    }
  },
  methods: {
    getMenuList() {
      this.postAxios("/sysUser/selSysPage", {}).then(res => {
        if (res.success) {
          this.menuData = res.content;
        } else {
          this.menuData = []
        }
      });
    },
    addBtn() {
      this.dialogTitle = '新增权限'
      this.ruleForm.menuName = ''
      this.ruleForm.action = ''
      this.ruleForm.sysPageId = this.currentClickItem.id
      this.dialogState = true
    },
    editBtn(row) {
      console.log(row, '编辑的那个实体类')
      this.dialogTitle = '编辑权限'
      this.ruleForm.menuName = row.menu_name
      this.ruleForm.action = row.action
      this.ruleForm.sysPageId = row.id
      this.dialogState = true
    },
    dialogCancel() {
      this.dialogState = false
      this.$refs.ruleForm.clearValidate();
    },
    //新增页面表单提交
    ruleFormSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          switch (this.dialogTitle) {
            case "新增权限":
              this.postAxios("/sysUser/addSysPermission",
                  this.ruleForm
              ).then(res => {
                if (res.success) {
                  this.$message.success('添加成功!')
                  this.dialogState = false
                  //查询一下当前页面下的权限列表
                  this.postAxios("/sysUser/selSysPageChildAndPermission", {
                    parameterMap: {
                      sysPageId: this.currentClickItem.id
                    }
                  }).then(res => {
                    if (res.success) {
                      if (res.entity) {
                        this.tableData = res.entity.roleList;
                      } else {
                        this.tableData = []
                      }
                    } else {
                      this.tableData = []
                    }
                  });
                }
              })

              break;
            case "编辑权限":
              this.postAxios("/sysUser/updSysPermission",
                  {
                    id: this.ruleForm.sysPageId,
                    sysPageId: this.currentClickItem.id,
                    menuName: this.ruleForm.menuName
                  }
              ).then(res => {
                if (res.success) {
                  this.$message.success('操作成功!')
                  this.dialogState = false
                  //查询一下当前页面下的权限列表
                  this.postAxios("/sysUser/selSysPageChildAndPermission", {
                    parameterMap: {
                      sysPageId: this.currentClickItem.id
                    }
                  }).then(res => {
                    if (res.success) {
                      if (res.entity) {
                        this.tableData = res.entity.roleList;
                      } else {
                        this.tableData = []
                      }
                    } else {
                      this.tableData = []
                    }
                  });
                }
              })
              break;
          }
        }
      });
    },
    //点击当前节点查看子列表
    handleNodeClick(data) {
      this.currentClickItem = data
      if (this.currentClickItem.parent_id !== 0) {
        this.addBtnState = true
        this.postAxios("/sysUser/selSysPageChildAndPermission", {
          parameterMap: {
            sysPageId: this.currentClickItem.id
          }
        }).then(res => {
          if (res.success) {
            if (res.entity) {
              this.tableData = res.entity.roleList;
            } else {
              this.tableData = []
            }
          } else {
            this.tableData = []
          }
        });
      } else {
        this.addBtnState = false
        this.tableData = []
      }
    }
  }
}
</script>

<style scoped>

</style>